// 操作数据--获取请求的数据,然后调用 mutations内的方法实现数据的修改
import moment from 'moment'
import { setParams } from "@/services/ajax";
import * as types from './mutations-types';
import { userInfoAjax } from '@/services/loginRegister';
import { trimSpace, parseJSONSafely, highlight } from '@/services/common';
import {
  fileContentAjax, taskProgressAjax, taskInfoAjax, taskContentAjax,
  filePreviewAjax, fileQACheckAjax, fileQACheckResultAjax, updateTargetAjax,
  fragmentAddRemarksAjax, fragmentGetRemarksAjax, modifyRecordAjax, sentMemoryAjax,
  sentTermAjax, fragmentRemarksDeleteAjax, fragmentRemarksUpdateAjax, dictTranslateAjax,
  afreshTranslateAjax, afreshTranslateAjax2, getMachineTranslation, mergeFragmentAjax, splitFragmentAjax, searchTermNumberAjax,
  autoFillTagAjax, taskInfoAjax2, submitTaskAjax, updataSentStatusAjax,
  remarkStatusAjax, addTermSentAjax, schoolTaskContentAjax, QACheckFileTaskAjax,
  ignoreQAFileTaskAjax, recoveryQAFileTaskAjax, projectInfoAjax, fileSentQAAjax,
  getCombineTopfileAjax, getCombineLeftfileAjax, addTermSentUpdateTagTargetV2, queryTemporaryPage,
  queryTaskScoreAndEval, getcountTargetSentIsNull, unLockOneAjax, unLockAllAjax,cancelConfirmationAjax  
} from '@/services/editorApi'
import { myMessageList } from "@/services/myMessage"
import { resolve } from 'core-js/fn/promise';
//获取译文句子为空数据
export const countTargetSentIsNull = async ({ commit }, params) => {
  const { result, success } = await getcountTargetSentIsNull(params);
  if (success) {
    commit(types.GET_COUNTTARGET_SENTIS, result.blankTargetSentIdList)
  }
}

//存储修改数据列表
export const setEditordataList = ({ commit, state }, data) => {
  commit(types.SET_EDITORDATA_LIST, data);
}
// 撤销存储修改数据列表（尾删）
export const deleteEditordataList = ({ commit, state }, data) => {
  const { editordataList } = state
  const deleteData = editordataList.pop()

  console.log(deleteData, editordataList, '---');

  // commit(types.SET_EDITORDATA_LIST, data);
}
// 更新/获取 评分结果
export const updateEvaluationResults = async ({ commit }, params) => {
  const { result, success } = await queryTaskScoreAndEval(params)
  try {
    if (success) {
      commit(types.UPDATE_EVALUATION_RESULTS, { ...result });
    }
  } catch (error) {
    commit(types.UPDATE_EVALUATION_RESULTS, {});
  }
}


// 修改theme 数据
export const updateTheme = async function ({ commit }, data) {
  commit(types.SET_THEME_LIST, data);
};
// 修改临时术语表
export const updateAddTemporaryTermList = async ({ commit, state }, params) => {
  const { success, result } = await addTermSentUpdateTagTargetV2(params)
  if (success) {
    const { currentViewMode } = state
    if (currentViewMode.name === 'newEditor') {
      const { isReplace } = params
      if (Number(isReplace) === 1 && result.length !== 0) {
        const { taskContentList } = state
        const { transSentRespVoList } = taskContentList
        if (transSentRespVoList && transSentRespVoList.length) {
          result.forEach((item) => {
            transSentRespVoList.every((editorItem) => {
              if (parseInt(item.id) === parseInt(editorItem.id)) {
                item.tagSourceSent && Reflect.set(editorItem, 'tagSourceSent', (item.tagSourceSent));
                item.tagTargetSent && Reflect.set(editorItem, 'tagTargetSent', (item.tagTargetSent));
                console.log(item, 'item')
                console.log(editorItem, 'editorItem')
                return false
              } else {
                return true
              }
            })
          });
          commit(types.SET_TASK_CONTENT, taskContentList);
        }
      }
    }
    return { success, result }
  }
}
export const updateImportOption = ({ commit }, data) => {
  commit(types.UPDATA_IMPORT_OPTION, data);
}

export const getTemporaryTermList = async ({ commit, state }, params) => {
  if (Array.isArray(params) && params.length === 0) {
    commit(types.UPDATE_TEMPORARY_TERM_LIST, []);
  } else {
    const { temporaryTermList } = state
    const { success, list, totalPage, totalRows } = await queryTemporaryPage(params)
    if (success) {
      if (list && list.length) {
        let map = new Map();
        let newList = [...temporaryTermList, ...list]
        for (let item of newList) {
          map.set(item.id, item);
        }
        newList = [...map.values()]
        newList.forEach(item => {
          item.isEditor = false
        })
        commit(types.UPDATE_TEMPORARY_TERM_LIST, newList);
      }

      return { success, totalPage, totalRows }
    }
  }
}


//获取当前用户信息
export const userInfo = async function ({ commit }) {
  const resp = await userInfoAjax(Object());
  if ((resp.status) === 200 && (resp.success)) {
    const result = (resp.result);
    commit(types.SET_USER_INFO, result);
  }
  return resp
};
//获取我的消息
export const getmyMessage = async function ({ commit, state }, data) {
  // console.log(data)
  const resp = await myMessageList(data);
  // console.log(resp)
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp);
    // console.log(result)
    commit(types.GET_MYMESSAGE_INFO, result);
    return result
  } else {
    return false
  }
};
//设置原译文数据
export const setUpdateSoutargetinfo = function ({ commit }, data) {
  commit(types.SET_PREVIEW_INFO, data);
};
//设置清空词典
export const setthird = function ({ commit }, data) {
  commit(types.SET_THIRD, data);
};
// //获取取消邀请状态
// export const getmyMessageStatus = function ({commit, state}, data) {
//   console.log(data)
//   commit(types.GET_MESSAGE_STATUS, data)
// };
//页面加载设置
export const setloading = ({ commit }) => {
  commit(types.SET_LOADING_INFO)
};

//页面加载取消
export const cancelLoading = ({ commit }) => {
  commit(types.CANCEL_LOADING_INFO)
};

//设置url参数
export const setUrlInfo = function ({ commit, state }, data) {
  commit(types.SET_URL_INFO, data)
};
//设置编辑模式
// export const setComparisonMode = function ({ commit }, data) {
//   commit(types.SET_COMPARISON_MODE, data);
// };
// //获取上下对照
// export const ComparisonTopList = async function ({ commit, state }, data) {
//   setloading({ commit, state });
//   const res = await getCombineTopfileAjax(data);
//   if ((res.status) === 200 && (res.success)) {
//     cancelLoading({ commit, state });
//     let { result } = res;
//     let { ComparisonList } = state
//     let { partIndex } = data
//     if (result) {
//       const { startSectionIndex, endSectionIndex, ifOnlyPreview, ifRepeatLock } = result
//       Reflect.set(ComparisonList, 'startSectionIndex', startSectionIndex)
//       Reflect.set(ComparisonList, 'endSectionIndex', endSectionIndex)
//       Reflect.set(ComparisonList, 'ifOnlyPreview', ifOnlyPreview)
//       Reflect.set(ComparisonList, 'ifRepeatLock', ifRepeatLock)
//       if (result.convertStr) {
//         if (partIndex == 1) {
//           let convertStr = `<div partType='source'  partIndex=${partIndex}>${result.convertStr}</div>`
//           Reflect.set(ComparisonList, 'convertStr', convertStr)
//         } else {
//           let convertStr = `${ComparisonList.convertStr}<div partType='source' partIndex=${partIndex}>${result.convertStr}</div>`;
//           Reflect.set(ComparisonList, 'convertStr', convertStr)
//         }
//         Reflect.set(ComparisonList, 'state', true)
//         commit(types.SET_COMPARISON_LIST, ComparisonList);
//       } else {
//         Reflect.set(ComparisonList, 'state', false)
//       }
//     }
//     console.log(ComparisonList, 'ComparisonList');
//   } else {
//     cancelLoading({ commit, state });
//   }
//   return res
// }
// //获取左右对照
// export const ComparisonLeftList = async function ({ commit, state }, data) {
//   setloading({ commit, state });
//   const res = await getCombineLeftfileAjax(data);
//   if ((res.status) === 200 && (res.success)) {
//     cancelLoading({ commit, state });
//     let result = res.result;
//     let ComparisonList = state.ComparisonList
//     if (result) {
//       if (result.convertStr && result.sourceStr) {
//         if (data.partIndex == 1) {
//           let convertStr = `<div partType='source'  partIndex=${data.partIndex}>${result.convertStr}</div>`
//           let targetStr = `<div partType='target'  partIndex=${data.partIndex}>${result.sourceStr}</div>`
//           Reflect.set(ComparisonList, 'convertStr', convertStr);
//           Reflect.set(ComparisonList, 'targetStr', targetStr);
//         } else {
//           let convertStr = `${ComparisonList.convertStr}<div partType='source' partIndex=${data.partIndex}>${result.convertStr}</div>`;
//           let targetStr = `${ComparisonList.targetStr}<div partType='target'  partIndex=${data.partIndex}>${result.sourceStr}</div>`
//           Reflect.set(ComparisonList, 'convertStr', convertStr);
//           Reflect.set(ComparisonList, 'targetStr', targetStr);
//         }
//         Reflect.set(ComparisonList, 'state', true)
//         commit(types.SET_COMPARISON_LIST, ComparisonList);
//       } else {
//         Reflect.set(ComparisonList, 'state', false)
//       }
//     }
//   } else {
//     cancelLoading({ commit, state });
//   }
//   return res
// }
//获取项目信息
export const projectInfo = async function ({ commit, state }, data) {
  const resp = await projectInfoAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    commit(types.SET_PROJECT_INFO, result);
    return result
  } else {
    return false
  }
};

//获取任务进度
export const getTaskProgress = async function ({ commit, state }, data) {
  const resp = await taskProgressAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result.progress);
    console.log('Progress:' + result)
    commit(types.SET_TASK_PROGRESS, result);
    return result
  }
};

//获取文件相关信息
export const getFileInfo = async function ({ commit, state }, data) {
  const resp = await taskInfoAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    commit(types.SET_FILE_INFO, result);
    return result;
  }
};

//设置文件相关信息--补充进度字段
export const setFileSupplyInfo = ({ commit, state }, data) => {
  commit(types.SET_FILE_INFO, data)
};

//获取任务相关信息
export const getFileTaskInfo = async function ({ commit, state }, data) {
  const resp = await taskInfoAjax2(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    commit(types.SET_FILE_TASK_INFO, result);
    return result;
  }
};

//设置文件相关信息--补充进度字段
export const setFileTaskSupplyInfo = ({ commit, state }, data) => {
  commit(types.SET_FILE_TASK_INFO, data)
};

//获取文件内容
export const getFileContent = async function ({ commit, state }, data) {
  setloading({ commit, state });
  // data.startSort = state.taskContentListParams.startSort
  const resp = await fileContentAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    let taskContentList = (result.transSentRespVoList);
    let mergeObj = Object();
    //合并当前数据和旧数据
    // console.log(data.startSort)
    let mergeRsult = []
    if (parseInt(data.startSort) === 1) {
      mergeRsult = [...(taskContentList)];
    } else {
      mergeRsult = [...state.taskContentList.transSentRespVoList, ...(taskContentList)];
    }
    //合成新的对象
    Reflect.set(mergeObj, 'ifOnlyPreview', (result.ifOnlyPreview));
    Reflect.set(mergeObj, 'ifRepeatLock', (result.ifRepeatLock));
    Reflect.set(mergeObj, 'totalPage', (result.totalPage));
    Reflect.set(mergeObj, 'totalRows', (result.totalRows));
    Reflect.set(mergeObj, 'transSentRespVoList', mergeRsult);
    cancelLoading({ commit, state });
    commit(types.SET_TASK_CONTENT, mergeObj);
    commit(types.SET_TASK_CONTENT_PARAMS, data);
  } else {
    cancelLoading({ commit, state });
  }
};

//获取任务内容
export const getTaskContent = async function ({ commit, state }, data) {
  setloading({ commit, state });
  // data.startSort = state.taskContentListParams.startSort
  const resp = await taskContentAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    let taskContentList = (result.transSentRespVoList);
    let mergeObj = Object();
    //合并当前数据和旧数据
    let mergeRsult = [...(taskContentList)];
    //合成新的对象
    Reflect.set(mergeObj, 'ifOnlyPreview', (result.ifOnlyPreview));
    Reflect.set(mergeObj, 'ifRepeatLock', (result.ifRepeatLock));
    Reflect.set(mergeObj, 'totalPage', (result.totalPage));
    Reflect.set(mergeObj, 'totalRows', (result.totalRows));
    Reflect.set(mergeObj, 'transSentRespVoList', mergeRsult);
    cancelLoading({ commit, state });
    commit(types.SET_TASK_CONTENT, mergeObj);
    commit(types.SET_TASK_CONTENT_PARAMS, data);
  } else {
    cancelLoading({ commit, state });
  }
};

export const continueLoadContent = async function ({ commit, state }, data) {
  Reflect.set(state.taskContentListParams, "isfilter", false)
  if ((data.urltype) === 'project') {
    var resp = await fileContentAjax(data);
  } else if (((data.urltype) === 'task') || ((data.urltype) === 'school')) {
    var resp = await taskContentAjax(data);
  }
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    state.taskContentList.ifOnlyPreview = result.ifOnlyPreview;
    state.taskContentList.ifRepeatLock = result.ifRepeatLock;
    state.taskContentList.totalPage = result.totalPage;
    state.taskContentList.totalRows = result.totalRows;
    state.taskContentList.transSentRespVoList = result.transSentRespVoList;
    // 使用startSort优化就使用这个
    // state.taskContentList.transSentRespVoList.push(...result.transSentRespVoList);
    commit(types.SET_TASK_CONTENT_PARAMS, data);
  } else {
    cancelLoading({ commit, state });
  }
}
//高校任务内容
export const getSchoolTaskContent = async function ({ commit, state }, data, mergeArray = Array()) {
  setloading({ commit, state });
  const resp = await schoolTaskContentAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = resp.result;
    let taskContentList = result.transSentRespVoList;
    let oldRsult = [...mergeArray];
    let mergeObj = {};
    //合并当前数据和旧数据
    let mergeRsult = [...oldRsult, ...(taskContentList)];
    //合成新的对象
    Reflect.set(mergeObj, 'ifOnlyPreview', result.ifOnlyPreview);
    Reflect.set(mergeObj, 'ifRepeatLock', result.ifRepeatLock);
    Reflect.set(mergeObj, 'transSentRespVoList', mergeRsult);
    //继续取数据的后续数据
    if (!!(taskContentList) && (taskContentList.length) === 50) {
      let newStartSort = (parseInt(data.startSort) + 50);
      let newRow = (parseInt(newStartSort) + 49);
      Reflect.set(data, 'startSort', newStartSort);
      Reflect.set(data, 'row', newRow);
      getSchoolTaskContent({ commit, state }, data, mergeRsult);
      console.log('继续获取列表')
    } else {
      //console.log('不满50条--列表获取完成');
      cancelLoading({ commit, state });
      commit(types.SET_TASK_CONTENT, mergeObj);
      commit(types.SET_TASK_CONTENT_PARAMS, data);
    }
  } else {
    cancelLoading({ commit, state });
  }
};

//储存当前光标的位置id
export const setCursorId = async function ({ commit, state }, data) {
  // console.log(data,"光标id")
  commit(types.SET_CURRENT_SENTENCE_ID, data)
};

//设置右键定位信息
export const setRightMouseInfo = async function ({ commit, state }, data) {
  commit(types.SET_RIGHT_MOUSE_POSITION, data)
};

//设置操作栏点击的栏目-已确定右侧展示具体的内容
export const setOerationSignInfo = async function ({ commit, state }, data) {
  commit(types.SET_OPERATION_SIGN, data)
};
// 设置修改句子在原译文预览中的页码
export const setWordPreview = ({ commit }, data) => {
  commit(types.SET_WORD_PREVIEW, data)
}
// 设置指定段落句段
export const setAppointPreview = async function ({ commit }, data) {
  const { result, status, success } = await filePreviewAjax(data);
  if (status === 200 && success) {
    let res = new Object()
    res.convertStr = result.convertStr
    res.sourceStr = result.sourceStr
    commit(types.SET_APPOINT_PREVIEW, res)
  }
}
// 修改的失焦的句子的数据
export const setSentCountInfo = function ({ commit }, data) {
  // console.log('@@@@',data);
  commit(types.SET_SENT_COUNT_INFO, data)
}

//获取原文预览
export const setPreviewInfo = async function ({ commit, state }, data) {
  const resp = await filePreviewAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    let filePreviewContent = (state.filePreviewContent);
    if (!!result && !!(result.sourceStr)) {
      if (data.partIndex === 1) {
        let sourceStr = `<div partType='source'  partIndex=${data.partIndex}>${result.sourceStr}</div>`
        Reflect.set(filePreviewContent, 'sourceStr', sourceStr)
      } else {
        let sourceStr = `${filePreviewContent.sourceStr}<div partType='source' partIndex=${data.partIndex}>${result.sourceStr}</div>`;
        Reflect.set(filePreviewContent, 'sourceStr', sourceStr)
      }

    } else {
      Reflect.set(filePreviewContent, 'sourceStr', (filePreviewContent.sourceStr))
    }
    //译文
    if (!!result && !!(result.convertStr)) {
      // let convertStr = `${filePreviewContent.convertStr}${result.convertStr}`;
      // Reflect.set(filePreviewContent, 'convertStr', convertStr)
      if (data.partIndex === 1) {
        let convertStr = `<div partType='target'  partIndex=${data.partIndex}>${result.convertStr}</div>`
        // console.log(convertStr, "convertStr");
        Reflect.set(filePreviewContent, 'convertStr', convertStr)
      } else {
        let convertStr = `${filePreviewContent.convertStr}<div partType='target'  partIndex=${data.partIndex}>${result.convertStr}</div>`;
        Reflect.set(filePreviewContent, 'convertStr', convertStr)
      }
    } else {
      Reflect.set(filePreviewContent, 'convertStr', (filePreviewContent.convertStr))
    }
    //记否继续
    if (!!result && (!!(result.sourceStr) && !!(result.convertStr))) {
      Reflect.set(filePreviewContent, 'state', true)
    } else {
      Reflect.set(filePreviewContent, 'state', false)
    }
    commit(types.SET_FILE_PREVIEW_CONTENT, filePreviewContent);
    commit(types.SET_PREVIEW_PARAMS_INFO, data)
  }
  return resp
};


export const setPreviewInfo2 = async function ({ commit, state }, data) {
  commit(types.SET_FILE_PREVIEW_CONTENT, data);
};

//设置QA检测的结果
export const setQACheckInfo = async function ({ commit, state }, data) {
  let param = {
    fileId: data,
  };
  let params = setParams(param);
  //获取任务key值
  const resp = await fileQACheckAjax(params);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    let resultparam = {
      taskKey: result
    };
    let resultparams = setParams(resultparam);
    //获取QA信息
    const resultResp = await fileQACheckResultAjax(resultparams);
    if ((resultResp.status) === 200 && (resultResp.success)) {
      let results = (resultResp.result);
      commit(types.SET_TASK_QACHECK_INFO, results)
    }
  }
  return resp
};

// 设置编辑模式
export const setEditorModeInfo = async function ({ commit, state }, data) {
  commit(types.SET_EDITOR_PATTERN_INFO, data)
};
//设置是否点击编辑原文的状态
export const setSourceeditEditorisSourceedit = async function ({ commit, state }, data) {
  commit(types.SET_SOURCEEDITOR_ISSTATUS, data)
}
//设置原文/译文编辑状态
export const setSourceeditEditorStatus = async function ({ commit, state }, data) {
  commit(types.SET_SOURCEEDITOR_STATUS, data)
}
export const setTargeteditEditorStatus = async function ({ commit, state }, data) {
  commit(types.SET_TARGETEDITOR_STATUS, data)
}
export const setEleStatus = async function ({ commit, state }, data) {
  commit(types.SET_ELE_STATUS, data)
}
//修改译文
export const updateTargetInfo = async function ({ commit, state }, data) {
  const { params, highlightTerms } = data
  const { sentId: id } = params
  console.log(params,'------------');
  // let id = data.params.sentId
  // let params = data.params;
  const resp = await updateTargetAjax(params)
  // .finally(() => {
  // cancelLoading({commit, state}); 
  // });
 
  if ((resp.status) === 200 && (resp.success)) {
    // 存储数据 用于实时更新原译文预览
    commit(types.SET_PREVIEW_INFO, data)
    // let results = (resp.result);
    const { result: results } = resp
    if (highlightTerms && Object.keys(highlightTerms)) {
      const { sourceTermSent, targetTermSent } = highlightTerms
      let taskContentListTerm = (state.taskContentList.transSentRespVoList);
      // console.log(data,'@@#$');
      taskContentListTerm.forEach(item => {
        if (item.id === params.sentId) {
          // item.sourceTermSent = results.sourceTermSent
          // item.targetTermSent = results.targetTermSent
          // 如果是记忆库插入 则修改匹配度
          params.similarPercent && params.isMemoryReplace && (item.similarPercent = params.similarPercent)
          // 如果是AT插入 则显示AT 去掉匹配度
          params.isATReplace && ( item.similarPercent = 0)
          item.sourceTermSent = sourceTermSent ? sourceTermSent : {}
          item.targetTermSent = targetTermSent ? targetTermSent : {}
        }
      })
      commit(types.SET_TERM, taskContentListTerm)
    }
    let tagSourceSent = JSON.parse(results.tagSourceSent);
    let tagTargetSent = JSON.parse(results.tagTargetSent);
    // let tagTargetSentHtml = JSON.parse(results.tagTargetSentHtml);
    let taskContentList = (state.taskContentList.transSentRespVoList);
    taskContentList.every((item) => {
      if (parseInt(item.id) === parseInt((params.sentId))) {
        //必要时候判断修改的原文或者译文
        // 更新成功-修改list数据-将旧数据存储在historyRecoverData中 方便回撤和恢复使用
        let oldTagSourceSent = (item.tagSourceSent) || (JSON.parse(item.tagSourceSent));
        let oldTagTargetSent = (item.tagTargetSent) === "" ? (item.tagTargetSent) : (JSON.parse(item.tagTargetSent));
        // let oldTagTargetSentHtml = (item.tagTargetSentHtml) == null ? (item.tagTargetSentHtml) : (JSON.parse(item.tagTargetSentHtml));
        //如果明确知道修改的原文或者译文--则只修改对应--否则原文和问都做数据的处理
        if ((data.langType) === 'source') {
          item.tagSourceSent = JSON.stringify(tagSourceSent);
        } else if ((data.langType) === 'target') {
          item.tagTargetSent = JSON.stringify(tagTargetSent);
        } else {
          item.tagSourceSent = JSON.stringify(tagSourceSent);
          item.tagTargetSent = JSON.stringify(tagTargetSent);
        }
        Reflect.set(item, 'tagTargetSentHtml', (results.tagTargetSentHtml));
        Reflect.set(item, 'status', (results.status));
        //恢复数据和撤销数据不作为数据的重新存储操作
        if (data.type) {
          let temp = Object();
          let timeStamp = (moment().valueOf());
          Reflect.set(temp, 'id', (item.id));
          Reflect.set(temp, 'content', (item.targetSent));
          if (oldTagSourceSent) {
            let obj = JSON.parse(oldTagSourceSent);
            Reflect.set(temp, 'TagSourceSent', obj.fragments[0].atoms);
          }
          if (!!oldTagTargetSent && (oldTagTargetSent.fragments) && !!(oldTagTargetSent.fragments.length) && !!(oldTagTargetSent.fragments[0].atoms)) {
            Reflect.set(temp, 'TagTargetSent', oldTagTargetSent.fragments[0].atoms);
          }
          if ((data.type) === 1) {
            // console.log(temp,'555555');
            //Map设置
            (state.revokeData).set(timeStamp, temp);
            //用户编辑-清空恢复队列
            (state.recoveryData).clear();
            //存储到历史记录中
            commit(types.SET_HISTORY_RECOVER_DATA_INFO, (state.revokeData));
          } else if ((data.type) === 2) {
            //Map设置
            (state.recoveryData).set(timeStamp, temp);
            //存储到历史记录中
            commit(types.SET_HISTORY_RECOVERY_DATA_INFO, (state.recoveryData));
          } else if ((data.type) === 3) {
            //Map设置
            (state.revokeData).set(timeStamp, temp);
            //存储到历史记录中
            commit(types.SET_HISTORY_RECOVER_DATA_INFO, (state.revokeData));
          } else if ((data.type) === 4) {//不做任何处理
             //Map设置
             (state.revokeData).set(timeStamp, temp);
             //用户编辑-清空恢复队列
             (state.recoveryData).clear();
             //存储到历史记录中
             commit(types.SET_HISTORY_RECOVER_DATA_INFO, (state.revokeData));
            //单独处理替换--改句如果还有内容重新高亮
            if (data.keyword) {
              if ((data.langType) === 'source') {
                if (!!tagSourceSent && !!(tagSourceSent.fragments) && !!(tagSourceSent.fragments.length) && (tagSourceSent.fragments[0].atoms)) {
                  let atoms = (tagSourceSent.fragments[0].atoms);
                  atoms.forEach((sourceItem) => {
                    if (sourceItem.data) {
                      let replaceInfo = (highlight((data.keyword), (sourceItem.data), results, 'source'));
                      Reflect.set(sourceItem, 'dataHTML', (replaceInfo.resultsList));
                      Reflect.set(sourceItem, 'searchState', true);
                    }
                  });
                  Reflect.set(item, 'tagSourceSent', JSON.stringify(tagSourceSent))
                }
              }
              if ((data.langType) === 'target') {
                
                if (!!tagTargetSent && !!(tagTargetSent.fragments) && !!(tagTargetSent.fragments.length) && (tagTargetSent.fragments[0].atoms)) {
                  let atoms = (tagTargetSent.fragments[0].atoms);
                  atoms.forEach((targetItem) => {
                    if (targetItem.data) {
                      let replaceInfo = (highlight((data.keyword), (targetItem.data), results, 'target'));
                      Reflect.set(targetItem, 'dataHTML', (replaceInfo.resultsList));
                      Reflect.set(targetItem, 'searchState', true);
                    }
                  });
                  Reflect.set(item, 'tagTargetSent', JSON.stringify(tagTargetSent))
                }
              }

            }
          }
        }
        return false
      } else {
        return true
      }
    });
    //修改对应的原文或者译文预览

    if (data && Reflect.has(data, 'params')) {
      let params = (data.params);
      const QA_ListParams = {
        taskId: params.taskId,
        fileId: params.fileId,
        // transModel: 1
      }
      // console.log(data, "data")
      switch (data.activeName) {
        case 'first':
          QACheckFileTaskInfo({ commit, state }, QA_ListParams);
          break;
        case 'second':
          let modifyRecordParams = Object();
          // console.log(state.urlInfo.projectId, params.fileId)
          Reflect.set(modifyRecordParams, 'transProjectId', state.urlInfo.projectId);
          Reflect.set(modifyRecordParams, 'transFileId', params.fileId);
          Reflect.set(modifyRecordParams, 'partIndex', 1);
          Reflect.set(modifyRecordParams, 'type', 'editorUpdate');
          Reflect.set(modifyRecordParams, 'id', id);
          Reflect.set(modifyRecordParams, 'taskId', state.urlInfo.taskId);
          // setModifyRecordInfo({ commit, state }, modifyRecordParams);
          break;
        case 'third':
          // if (!!params && !!(params.sourceTagFragmentVo)) {
          //   if (!!tagSourceSent && !!(tagSourceSent.fragments)) {
          //     let sourceText = '';
          //     let fragments = (tagSourceSent.fragments[0].atoms);
          //     fragments.forEach((item) => {
          //       if ((item.tagType) === 'text') {
          //         sourceText = `${trimSpace(sourceText)}${trimSpace(item.data)}`
          //       }
          //     });
          // console.log(state.setPreviewInfo, "setPreviewInfo");
          // let dom = document.querySelector(`span[sid='${data.params.sentId}'][key='${state.setPreviewInfo.key}']`);
          // console.log(dom);
          // dom.innerHTML = state.setPreviewInfo.text
          // if (dom.length) {
          //   dom[0].innerHTML = sourceText;
          // }
          //   }
          // }
          break;
        case 'fourth':
          // if (!!params && !!(params.targetTagFragmentVo)) {
          //   if (!!tagTargetSent && !!(tagTargetSent.fragments)) {
          //     let targetText = '';
          //     let fragments = (tagTargetSent.fragments[0].atoms);
          //     fragments.forEach((item) => {
          //       if ((item.tagType) === 'text') {
          //         targetText = `${trimSpace(targetText)}${trimSpace(item.data)}`
          //       }
          //     });
          //     let dom = document.querySelectorAll(`span[sid='${data.params.sentId}']`);
          //     if (dom.length) {
          //       dom[1].innerHTML = targetText;
          //     }
          //   }
          // }
          break;
      }
    }
    commit(types.SET_TASK_CONTENT, (state.taskContentList));
    return true
  } else {
    return false
  }
};
//筛选获取数据
export const changeFilter = async function ({ commit, state }, data) {
  let contentParams = (state.taskContentListParams);
  Reflect.set(contentParams, data.type, data.value);
  Reflect.set(contentParams, 'startSort', 1);
  Reflect.set(contentParams, "isfilter", true)
  switch ((state.urlInfo.type)) {
    case 'project':
      getFileContent({ commit, state }, contentParams);
      break;
    case 'task':
      getTaskContent({ commit, state }, contentParams);
      break;
    case 'school':
      getSchoolTaskContent({ commit, state }, contentParams);
      break;
  }
}

//更新完成做QA检测
export const fragmentQAInfo = async function ({ commit, state }, data) {
  let params = setParams(data);
  const resp = await fileSentQAAjax(params);
  if ((resp.status) === 200 && (resp.success)) {
    let results = (resp.result);
    //  翻译建议批注是否显示
    if ((data.taskType) !== 1) {
      commit(types.SET_SUGGEST_REMARKS_STATE, true);
    } else {
      commit(types.SET_SUGGEST_REMARKS_STATE, false);
    }
    commit(types.SET_FRAGMENT_QACHECK_INFO, results);
    return true
  } else {
    return false
  }
};


//设置字体大小
export const setEditorFontSizeInfo = async function ({ commit, state }, data) {
  commit(types.SET_FONT_SIZE_INFO, data)
};

//设置主题颜色
export const setThemeInfo = async function ({ commit, state }, data) {
  commit(types.SET_THEME_INFO, data)
};

//设置主题颜色
export const setSearchInfo = async function ({ commit, state }, data) {
  commit(types.SET_SEARCH_INFO, data)
};

//设置修改记录
export const setModifyRecordInfo = async function ({ commit, state }, data) {
  // console.log(data,'--------------');
  const resp = await modifyRecordAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    // console.log(result,'@##$$')
    let mergeData = Object();
    // let targetSent=result
    // let map = new Map()
    let arr = []
    // for (const item of result) {
    //   if (!map.has(item.sentId)) {
    //     map.set(item.sentId, item)
    //   }
    // }
    arr = [...result]
    // console.log(arr)
    if (((data.type) === 'editorUpdate')) {
      Reflect.deleteProperty(data, 'type');
      Reflect.set(mergeData, 'result', arr);
    } else {
      if (data.partIndex === 1) {
        let mergeResult = arr;
        Reflect.set(mergeData, 'result', mergeResult);
      } else {
        let mergeResult = [...(state.modifyRecord.result), ...arr];
        Reflect.set(mergeData, 'result', mergeResult);
      }

    }
    // console.log(arr);
    if ((arr.length) === 10) {
      Reflect.set(mergeData, 'state', true);
    } else {
      Reflect.set(mergeData, 'state', false);
    }
    commit(types.SET_MODIFY_RECORD_INFO, mergeData);
    commit(types.SET_MODIFY_RECORD_PARAMS_INFO, data);
  }
};

//设置修改记录参数
export const setModifyRecordParamsInfo = async function ({ commit, state }, data) {
  commit(types.SET_MODIFY_RECORD_PARAMS_INFO, data);
};

//设置文章预览参数
export const setPreviewParamsInfo = async function ({ commit, state }, data) {
  commit(types.SET_PREVIEW_PARAMS_INFO, data)
};

//设置修改记录信息
export const setModifyRecordInfo2 = async function ({ commit, state }, data) {
  commit(types.SET_MODIFY_RECORD_INFO, data);
};

//设置QA的整体状态
export const setQAStateInfo = async function ({ commit, state }, data) {
  commit(types.SET_QA_STATE_INFO, data);
};
// 请求当前句字机翻
export const setSentenceMt = async ({ commit, state }, data) => {
  return await getMachineTranslation(setParams(data));

}
// 设置当前句字机翻
export const setSentenceMt2 = async ({ commit, state }, data) => {
  let formatData = [...data]
  if (!data) {
    return
  }
  formatData.forEach(item => {
    item.convertStr = item.convertStr ? JSON.parse(item.convertStr) : ''
    item.atoms = item.convertStr ? item.convertStr.fragments[0].atoms : []
  })
  commit(types.UPDATE_FRAGMENT_SENTENCE_MT, formatData);
}
//请求记忆库
export const setSentMemoryInfo = async function ({ commit, state }, data) {
  // console.log('获取记忆库数据');
  return await sentMemoryAjax(data)
};

//请求术语库
export const setSentTermInfo = async function ({ commit, state }, data) {
  return await sentTermAjax(data)
};

//设置记忆库
export const setSentMemoryInfo2 = async function ({ commit, state }, data) {
  commit(types.SET_FRAGMENT_MEMORY_INFO, data);
};

//设置术语库
export const setSentTermInfo2 = async function ({ commit, state }, data) {
  commit(types.SET_FRAGMENT_TERM_INFO, data);
};

//设置批注
export const setFragmentInfo = async function ({ commit, state }, data) {
  let modeType = null
  if (data.modeType) {
    modeType = data.modeType
    Reflect.deleteProperty(data, 'modeType')
  }
  const { status, success, result } = await fragmentAddRemarksAjax(data);
  if (status === 200 && success) {
    const { transSentRespVoList } = state.taskContentList
    if (!modeType) {
      transSentRespVoList.forEach((items) => {
        if (parseInt(items.id) === parseInt(result.sentId)) {
          Reflect.set(items, 'remarkStatus', (result.status));
        }
      });
      commit(types.SET_TASK_CONTENT, (state.taskContentList));
    }
  }
  return { success, result }
};

//获取批注
export const getCurrentRemarksInfo = async function ({ commit, state }, data) {
  const { status, success, result } = await fragmentGetRemarksAjax(data);
  if ((status) === 200 && (success)) {
    result.forEach(item => {
      item.disabled = true
    })
    commit(types.SET_CURRENT_REMARKS_INFO, result);
  }
};
//删除当前批注
export const deleteSentRemarksInfo = async function ({ commit, state }, data) {
  const resp = await fragmentRemarksDeleteAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let params = Object();
    Reflect.set(params, 'projectId', (state.urlInfo.projectId));
    Reflect.set(params, 'sid', (data.item.sentId));
    Reflect.set(params, 'transFileId', (data.item.transFileId));
    const resps = await remarkStatusAjax(params);
    if ((resps.status) === 200 && (resps.success)) {
      let result = (resps.result);
      let taskContentList = (state.taskContentList.transSentRespVoList);
      taskContentList.forEach((items) => {
        if (parseInt(items.id) === parseInt(result.id)) {
          Reflect.set(items, 'remarkStatus', (result.remarkStatus));
          return false
        } else {
          return true
        }
      });
      commit(types.SET_TASK_CONTENT, (state.taskContentList));
    }
  }
  return !!((resp.status) === 200 && (resp.success));
};

//更新当前的批注
export const updateSentRemarksInfo = async function ({ commit, state }, data) {
  const resp = await fragmentRemarksUpdateAjax(data);
  return !!((resp.status) === 200 && (resp.success));
};

//词典查词
export const translateDictionary = async function ({ commit, state }, data) {
  const resp = await dictTranslateAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    commit(types.SET_TRANSLATE_DICT_LIST_INFO, result);
  }
};

//存储临时句子的id
export const setTempSentenceId = async function ({ commit, state }, data) {
  commit(types.SET_TEMP_SENTENCE_ID_INFO, data);
};

//重新机翻
export const afreshTranslate = async function ({ commit, state }, data) {
  let params = setParams(data);
  const resp = await afreshTranslateAjax(params);
  if ((resp.status) === 200 && (resp.success)) {
    // let result = (resp.result);
    // let taskContentList = (state.taskContentList.transSentRespVoList);
    // taskContentList.every((item) => {
    //   if (parseInt(item.id) === parseInt(result.sid)) {
    //     Reflect.set(item, 'tagTargetSent', (result.convertStr));

    //     return false
    //   } else {
    //     return true
    //   }
    // });
    let contentParams = (state.taskContentListParams);
    if (state.urlInfo.type === "project") {
      getFileContent({ commit, state }, contentParams);
    } else {
      getTaskContent({ commit, state }, contentParams);
    }

    // commit(types.SET_TASK_CONTENT, (state.taskContentList));
    // return (resp.result);
  }
};

//设置右侧显示第几个栏目
export const setEditorRightActiveName = ({ commit }, data) => {
  commit(types.SET_EDITOR_RIGHT_ACTIVE_NAME_INFO, data);
};

//合并片段
export const mergeFragment = async function ({ commit, state }, data) {
  const resp = await mergeFragmentAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    let contentParams = (state.taskContentListParams);
    if (state.urlInfo.type === "project") {
      getFileContent({ commit, state }, contentParams);
    } else {
      getTaskContent({ commit, state }, contentParams);
    }
    let taskContentList = (state.taskContentList.transSentRespVoList);
    taskContentList.every((item, index) => {
      if (parseInt(item.id) === parseInt((result.id))) {
        item.companyCode = (result.companyCode);
        item.id = (result.id);
        item.mtTargetSent = (result.mtTargetSent);
        item.prevTargetSent = (result.prevTargetSent);
        item.reviserUserId = (result.reviserUserId);
        item.row = (result.row);
        item.sameFileSentNo = (result.sameFileSentNo);
        item.sameProjectSentNo = (result.sameProjectSentNo);
        item.secondReviserUserId = (result.secondReviserUserId);
        item.sectionIndex = (result.sectionIndex);
        item.sectionType = (result.sectionType);
        item.sort = (result.sort);
        item.sourceMd516 = (result.sourceMd516);
        item.sourceSent = (result.sourceSent);
        item.sourceWordNum = (result.sourceWordNum);
        item.status = (result.status);
        item.tagSourceSent = (result.tagSourceSent);
        item.tagTargetSent = (result.tagTargetSent);
        item.tagTargetSentHtml = (result.tagTargetSentHtml);
        item.targetSent = (result.targetSent);
        item.targetWordNum = (result.targetWordNum);
        item.templateKey = (result.templateKey);
        item.transFileId = (result.transFileId);
        item.transProjectId = (result.transProjectId);
        item.transUserId = (result.transProjectId);
        item.unlockStatus = (result.unlockStatus);
        taskContentList.splice((index - 1), 1);
        return false
      } else {
        return true
      }
    });
    commit(types.SET_TASK_CONTENT, (state.taskContentList));
  }

};

//拆分句子
export const splitFragment = async function ({ commit, state }, data) {
  const resp = await splitFragmentAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    let contentParams = (state.taskContentListParams);
    if (state.urlInfo.type === "project") {
      getFileContent({ commit, state }, contentParams);
    } else {
      getTaskContent({ commit, state }, contentParams);
    }
    let taskContentList = (state.taskContentList.transSentRespVoList);
    taskContentList.every((item2, index) => {
      if (parseInt(item2.id) === parseInt(data.sentId)) {
        taskContentList.splice(index, 1);
        taskContentList.splice(index, 0, ...result);
        return false
      } else {
        return true
      }
    });
    commit(types.SET_TASK_CONTENT, (state.taskContentList));
    //拆分完成清除光标位置信息
    return true
  }
};

//更新撤销的数组数据
export const setRevokeInfo = async function ({ commit, state }, data) {
  commit(types.SET_HISTORY_RECOVER_DATA_INFO, data);
};

//更新恢复的数组数据
export const setRecoveryInfo = async function ({ commit, state }, data) {
  commit(types.SET_HISTORY_RECOVERY_DATA_INFO, data);
};

//记录光标拆分的位置--前提必须是光标将句段拆成两句
export const recordCursorPosition = async function ({ commit, state }, data) {
  commit(types.RECORD_CURSOR_POSITION_INFO, data);
};

//记录光标译文的位置 --方便后续点击插入内容
export const recordCursorPositionTarget = async function ({ commit, state }, data) {
  // console.log(data,"记录的光标位置");

  commit(types.RECORD_CURSOR_POSITION_TARGET_INFO, data);
};

//更新组件状态
export const setUpdateState = async function ({ commit, state }, data) {
  commit(types.SET_UPDATE_STATE_INFO, data);
};

//查询文件中术语的个数searchTermNumberAjax
export const searchTermNumber = async function ({ commit, state }, data) {
  const resp = await searchTermNumberAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    return (resp.result);
  } else {
    return false
  }
};

//自动填充--如果请求成功-重新获取列表数据
export const autoFillTag = async function ({ commit, state }, data) {
  let params = setParams(data);
  setloading({ commit, state });
  const resp = await autoFillTagAjax(params);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    let contentParams = state.taskContentListParams;
    if (result && (parseInt(result.percent) === 100)) {
      if (state.urlInfo && state.urlInfo.type) {
        if (state.urlInfo.type === 'project') {
          getFileContent({ commit, state }, contentParams);
        } else if (state.urlInfo.type === 'task') {
          getTaskContent({ commit, state }, contentParams)
        } else if (state.urlInfo.type === 'school') {
          // getSchoolTaskContent({ commit, state }, contentParams)
          getTaskContent({ commit, state }, contentParams)
        }
      }
      cancelLoading({ commit, state });
    } else if (result && (parseInt(result.percent) !== 100)) {
      Reflect.set(data, 'taskKey', (result.taskKey));
      setTimeout(() => {
        autoFillTag({ commit, state }, data);
      }, 2500)
    }

  }
};

// 提交任务
export const submitTask = async function ({ commit, state }, data) {
  return await submitTaskAjax(data);
};
//更新句子的状态
export const updataSentStatus = async function ({ commit, state }, data) {
  const resp = await updataSentStatusAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    let taskContentList = (state.taskContentList.transSentRespVoList);
    taskContentList.every((item) => {
      if (parseInt(item.id) === parseInt((data.sentId))) {
        Reflect.set(item, 'status', result);
        const QA_ListParams = {
          taskId: data.taskId,
          fileId: data.fileId,
          // transModel: 1
        }
        QACheckFileTaskInfo({ commit, state }, QA_ListParams)
        return false
      } else {
        return true
      }
    })
    commit(types.SET_TASK_CONTENT, (state.taskContentList));
  }
};

//添加术语
export const addTermsSent = async function ({ commit, state }, data) {
  const resp = await addTermSentAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    let contentParams = (state.taskContentListParams);
    if (state.urlInfo.type === "project") {
      getFileContent({ commit, state }, contentParams);
    } else {
      getTaskContent({ commit, state }, contentParams);
    }
    if ((parseInt(data.isReplace) === 1) && !!(result.length)) {
      let editorListInfo = state.taskContentList;
      if (!!editorListInfo && !!(editorListInfo.transSentRespVoList)) {
        let editorList = (editorListInfo.transSentRespVoList);
        result.forEach((item) => {
          // console.log(item);
          editorList.every((editorItem) => {
            if (parseInt(item.id) === parseInt(editorItem.id)) {
              // console.log(editorItem);
              if (!!item && !!(item.tagSourceSent)) {
                Reflect.set(editorItem, 'tagSourceSent', (item.tagSourceSent));
              }
              if (!!item && !!(item.tagTargetSent)) {
                Reflect.set(editorItem, 'tagTargetSent', (item.tagTargetSent));
              }
              console.log("添加术语")
              return false
            } else {
              return true
            }
          })
        });
        commit(types.SET_TASK_CONTENT, editorListInfo);
      }
    }
    return true
  } else {
    return false
  }
};

//文件-任务的QA检测 QACheckFileTaskAjax
export const QACheckFileTaskInfo = async function ({ commit, state }, data) {
  const params = { ...data }
  // Reflect.set(params, 'fileId', data);
  const resp = await QACheckFileTaskAjax(params);
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    result && result.sort((first, second) => {
      return (parseInt(first.transFileSentId) - parseInt(second.transFileSentId))
    });
    commit(types.SET_TASK_QACHECK_INFO, result);
  }
  return resp
};

//忽略所有QA检测
export const ignoreQAFileTaskInfo = async function ({ commit, state }, data) {
  const resp = await ignoreQAFileTaskAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    const QA_ListParams = {
      taskId: state.urlInfo.taskId,
      fileId: state.urlInfo.fileId,
      // transModel: 1
    }
    QACheckFileTaskInfo({ commit, state }, QA_ListParams);
  }
  return resp
};

//恢复所有QA检测
export const recoveryQAFileTaskInfo = async function ({ commit, state }, data) {
  const resp = await recoveryQAFileTaskAjax(data);
  if ((resp.status) === 200 && (resp.success)) {
    const QA_ListParams = {
      taskId: state.urlInfo.taskId,
      fileId: state.urlInfo.fileId,
      // transModel: 1
    }
    QACheckFileTaskInfo({ commit, state }, QA_ListParams);
  }
  return resp
};

//设置更新的类型
export const setUpdataFragmentType = async function ({ commit, state }, data) {
  commit(types.SET_UPDATA_FRAGMENT_TYPE, data);
};

//设置翻译建议批注的显示状态
export const setSuggestRemarks = async function ({ commit, state }, data) {
  commit(types.SET_SUGGEST_REMARKS_STATE, data);
};

//设置编辑器底部栏目名字
export const setEditorBottomActiveName = async function ({ commit, state }, data) {
  commit(types.SET_EDITOR_BOTTOM_ACTIVE_NAME, data);
};

//清洗列表数据
export const cleanListdata = async function ({ commit, state }, data) {
  if (Reflect.has((state.taskContentList), 'transSentRespVoList')) {
    let transSentRespVoList = (state.taskContentList.transSentRespVoList);
    if (transSentRespVoList.length) {
      transSentRespVoList.forEach((item) => {
        let tagSourceSent = !!(item.tagSourceSent) && JSON.parse((item.tagSourceSent));
        let tagTargetSent = !!(item.tagTargetSent) && JSON.parse((item.tagTargetSent));
        if (tagSourceSent && (tagSourceSent.fragments)) {
          let sourceFragments = (tagSourceSent.fragments);
          if ((sourceFragments.length) && (sourceFragments[0].atoms)) {
            let sourceAtoms = (sourceFragments[0].atoms);
            sourceAtoms.forEach((item) => {
              Reflect.deleteProperty(item, 'dataHTML');
              Reflect.deleteProperty(item, 'searchState');

            })
          }
        }
        if (tagTargetSent && (tagTargetSent.fragments)) {
          let targetFragments = (tagTargetSent.fragments);
          if ((targetFragments.length) && (targetFragments[0].atoms)) {
            let targetAtoms = (targetFragments[0].atoms);
            targetAtoms.forEach((item) => {
              Reflect.deleteProperty(item, 'dataHTML');
              Reflect.deleteProperty(item, 'searchState');
            })
          }
        }
      });
      // console.log(transSentRespVoList)
      commit(types.SET_TASK_CONTENT, (state.taskContentList));
    }
  }
};

//解锁单个句子
export const unLockOne = async function ({ dispatch, state }, payload) {
  let { params, data } = payload
  const res = await unLockOneAjax(params)
  if (res.success) {
    if(data.marker==1){
      dispatch('getTaskContent', data)
    }else if(data.marker == 2){
      dispatch('getFileContent', data)
    }
  }
}
//解锁全部句子
export const unLockAll = async function ({ dispatch, state }, payload) {
  let { params, data } = payload
  if(data.marker == 1){ //从任务中解锁
    Reflect.deleteProperty(params,'taskId')
    const res = await unLockAllAjax(params)
    if (res.success) { 
        dispatch('getTaskContent', data)
    }
  }else if(data.marker == 2){ //从项目中解锁
    const res = await unLockAllAjax(params)
    if (res.success) {
        dispatch('getFileContent', data)
    }
  }
}
//取消确认(编辑器取消打勾)
export const cancelConfirmation = async function ({ commit,dispatch, state }, data) {
  // let { params, data } = payload
  const resp = await cancelConfirmationAjax(data)
  if ((resp.status) === 200 && (resp.success)) {
    let result = (resp.result);
    console.log(result)
    let taskContentList = (state.taskContentList.transSentRespVoList);
    taskContentList.every((item) => {
      if (parseInt(item.id) === parseInt((data.sentId))) {
        Reflect.set(item, 'status', result);
        const QA_ListParams = {
          taskId: data.taskId,
          fileId: data.fileId,
          // transModel: 1
        }
        dispatch('QACheckFileTaskInfo',QA_ListParams) 
        return false
      } else {
        return true
      }
    })
    commit(types.SET_TASK_CONTENT, (state.taskContentList));
  }
}